export { default as DuotonePicker } from './duotone-picker';
export { default as DuotoneSwatch } from './duotone-swatch';
